<style scoped>
.floating-wrapper {
    position: absolute;
    top: 0;
    z-index: 2;
    height: 100%;
    /* move to left by 1rem to align to top bar(px-4) */
    transform: translate(-1rem, 0%);
    background-color: rgba(0, 0, 0, 0.5);
}

.floating-menu {
    position: absolute;
    top: 0;
    z-index: 3;
    /* move to left by 4rem to align to top bar(px-4) */
    transform: translate(-1rem, 0%);
    height: 100%;

    @apply border-2 border-primary bg-white shadow;
}

.slide-enter-active {
    animation: slide 0.5s;
    transition: opacity 0.5s;
}
.slide-leave-active {
    animation: slide 0.5s reverse;
    transition: opacity 0.5s;
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
}

@keyframes slide {
    0% {
        transform: translate(-100%, 0%);
    }
    100% {
        transform: translate(-1rem, 0%);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>

<template>
    <div>
        <transition name="fade">
            <div
                v-if="showMenu"
                class="floating-wrapper w-full max-w-site"
                @click="$emit('close')"
            ></div>
        </transition>
        <transition name="slide">
            <div
                v-if="showMenu"
                class="floating-menu max-w-site w-3/5 sm:w-64 p-2"
            >
                <div class="flex">
                    <div class="inline-block text-xl mr-auto">產品分類</div>
                    <div class="inline-block">
                        <button @click="$emit('close')">
                            <close />
                        </button>
                    </div>
                </div>
                <br />
                <ul>
                    <li>
                        <button @click="$emit('setProdCatgSlctKey', undefined)">
                            {{ '所有產品' }} ({{ prodList.length }})
                        </button>
                    </li>
                    <li v-for="(p, pi) in prodListGroupByProdCatg" :key="pi">
                        <button
                            @click="$emit('setProdCatgSlctKey', p.prodCatgKey)"
                        >
                            {{ p.prodCatgDesp }} ({{ p.prodList.length }})
                        </button>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import close from '../assets/svg/close.svg';

export default {
    props: {
        showMenu: { default: false },
        prodList: { type: Array, default: () => [] }
    },
    components: { close },
    data() {
        return {};
    },
    computed: {
        prodCatgList() {
            return this.$store.state.prodCatgList || [];
        },
        prodListGroupByProdCatg() {
            let list = this.prodCatgList.map(prodCatg => {
                const productList = this.prodList.filter(
                    prod => prod.prodCatgSlctKey === prodCatg.id
                );
                return {
                    prodCatgKey: prodCatg.id,
                    prodCatgDesp: prodCatg.slctDesp,
                    prodList: productList
                };
            });

            const prodListWithNullProdCatgKey = this.prodList.filter(
                prod =>
                    prod.prodCatgSlctKey === undefined ||
                    prod.prodCatgSlctKey === null
            );
            list.push({
                prodCatgKey: 0,
                prodCatgDesp: '其他',
                prodList: prodListWithNullProdCatgKey
            });
            return list.filter(obj => obj.prodList.length > 0);
        }
    }
};
</script>
